/**
 * Configuration file for card stacks used in the Stack Trainer application.
 * Each stack includes a name, creator, and card order.
 */

/**
 * Card stacks array containing all available stacks for memorization practice.
 * @type {Array<{name: string, creator: string, order: string}>}
 */
export const stacks = [
  {
    name: 'Particle Stack',
    creator: 'Joshua Jay',
    order:
      'AH,KS,AD,KC,2H,QS,2D,QC,3H,JS,3D,JC,4H,10S,4D,10C,5H,9S,5D,9C,6H,8S,6D,8C,7H,7S,7D,7C,8H,6S,8D,6C,9H,5S,9D,5C,10H,4S,10D,4C,JH,3S,JD,3C,QH,2S,QD,2C,KH,AS,KD,AC',
  },
  {
    name: 'Mnemonica',
    creator: 'Juan Tamariz',
    order:
      '4C,2H,7D,3C,4H,6D,AS,5H,9S,2S,QH,3D,QC,8H,6S,5S,9H,KC,2D,JH,3S,8S,6H,10C,5D,KD,2C,3H,8D,5C,KS,JD,8C,10S,KH,JC,7S,10H,AD,4S,7H,4D,AC,9C,JS,QD,7C,QS,10D,6C,AH,9D',
  },
  {
    name: 'Aronson Stack',
    creator: 'Simon Aronson',
    order:
      'JS,KC,5C,2H,9S,AS,3H,6C,8D,AC,10S,5H,2D,KD,7D,8C,3S,AD,7S,5S,QD,AH,8S,3D,7H,QH,5D,7C,4H,KH,4D,10D,JC,JH,10C,JD,4S,10H,6H,3C,2S,9H,KS,6S,4C,8H,9C,QS,6D,QC,2C,9D',
  },
  {
    name: 'Memorandum Stack',
    creator: 'Woody Aragon',
    order:
      'JS,7C,10H,AD,4C,7H,4D,AS,4H,7D,4S,AH,10D,7S,JC,KD,10S,8C,JH,AC,KS,5C,8H,3D,QS,KH,9C,QH,6C,9H,2D,3C,6H,5D,2S,3H,8D,5S,KC,JD,8S,10C,2C,5H,6D,3S,2H,9D,6S,QC,QD,9S',
  },
  {
    name: 'Nikola Stack',
    creator: 'Luis Nikola',
    order:
      '6D,5C,KC,JH,5S,9D,9S,QH,3C,10C,KS,AH,4D,JD,KD,KH,2D,QC,9C,10H,8D,2C,AC,7H,7C,4S,7S,9H,8S,6S,6C,2H,AS,JS,4C,5H,10S,AD,JC,4H,2S,7D,QS,3H,3S,8C,10D,6H,5D,3D,QD,8H',
  },
  {
    name: 'Redford Stack',
    creator: 'Patrick Redford',
    order:
      'QH,2S,5D,8C,JH,KS,10H,7C,4D,AS,8H,5C,2D,QS,9H,6C,3D,10S,7H,4C,AD,JS,9S,6H,3C,KD,QD,10D,7S,4H,AC,JD,8S,5H,2C,2H,QC,9D,6S,3H,KC,4S,AH,JC,8D,5S,3S,KH,10C,7D,6D,9C',
  },
  {
    name: 'Stebbins Stack',
    creator: 'Si Stebbins',
    order:
      'AC,4H,7S,10D,KC,3H,6S,9D,QC,2H,5S,8D,JC,AH,4S,7D,10C,KH,3S,6D,9C,QH,2S,5D,8C,JH,AS,4D,7C,10H,KS,3D,6C,9S,QD,2C,5H,8S,JD',
  },
  {
    name: 'Joyal CHaSeD',
    creator: 'Martin Joyal',
    order:
      'JH,6C,6H,4C,10D,AD,7C,4H,9C,5D,QH,AS,KC,7H,10S,4S,JS,9H,KD,5S,7S,2C,QC,AH,10H,6S,9S,7D,QD,5H,KH,4D,3C,3H,10C,9D,QS,3S,3D,2H,8C,2S,JC,2D,8H,8S,KS,AC,JD,5C,8D,6D',
  },
]

/**
 * Resource paths for card images and assets
 */
export const RESOURCES = {
  CARD_CDN: 'https://vinc.gumlet.io/stack-trainer/cards/',
  NUMBER_CDN: 'https://vinc.gumlet.io/stack-trainer/numbers/',
  ANSWER_URL: 'https://vinc.gumlet.io/stack-trainer/answer.png',
  STORAGE_KEY: 'stack-trainer-settings',
}

/**
 * Default settings for the application
 */
export const DEFAULT_SETTINGS = {
  mode: 'random',
  stackStart: 1,
  stackEnd: 5,
  timerSeconds: 0,
  selectedStackName: 'Particle Stack',
  displayMode: 'multiple',
}

/**
 * Available modes for the game
 */
export const GAME_MODES = {
  RANDOM: 'random',
  GUESS_POSITION: 'guess-position',
  GUESS_CARD: 'guess-card',
}

/**
 * Available display modes for the game
 */
export const DISPLAY_MODES = {
  MULTIPLE: 'multiple',
  AUTO: 'auto',
}
